module.exports = __webpack_public_path__ + "linkedin.webp?518be6f697b6a896bd57fb2367a423a5";